import React from "react"
import Grid from "@material-ui/core/Grid"
import TextField from "@material-ui/core/TextField"
import Button from "@material-ui/core/Button"
import axios from "axios" // For making client request.
import ReCAPTCHA from "react-google-recaptcha"

import Snackbar from "@material-ui/core/Snackbar"
import IconButton from "@material-ui/core/IconButton"
import CloseIcon from "@material-ui/icons/Close"

const SubmitForm = props => {
  const [values, setValues] = React.useState({
    name: "",
    email: "",
    message: "",
    subject: "",
    company: "",
  })

  const [formStatus, setFormStatus] = React.useState("unverified")

  const onChange = () => {
    setFormStatus("verified")
  }

  const handleChange = name => event => {
    setValues({ ...values, [name]: event.target.value })
  }

  function handleClose(event, reason) {
    if (reason === "clickaway") {
      return
    }
    setFormStatus(0)
  }

  const handleForm = e => {
    setFormStatus("sending")
    const payload = {
      type: props.type,
      sender: {
        name: values["name"],
        email: values["email"],
        company: values["company"],
      },
      subject: values["subject"],
      message: values["message"],
      product: {
        name: "server",
        version: "8.0.0",
      },
      plan: props.plan,
    }
    axios
      .post(
        `https://rakyfxblul.execute-api.us-west-2.amazonaws.com/prod/createSupportMail`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then(function(response) {
        console.log(response)
        setValues({
          name: "",
          email: "",
          message: "",
          company: "",
          subject: "",
        })
        setFormStatus(1)
      })
      .catch(function(error) {
        console.log(error)
        setFormStatus(-1)
      })

    e.preventDefault()
  }

  return (
    <Grid container justify="center">
      <Grid container style={{ margin: 20, width: 310 }} justify={"center"}>
        <form id="contactForm" method="POST">
          <TextField
            id="filled-name"
            label="Name"
            value={values.name}
            onChange={handleChange("name")}
            margin="normal"
            variant="filled"
            name="Name"
            type="text"
            fullWidth
          />
          <TextField
            id="filled-email-input"
            onChange={handleChange("email")}
            value={values.email}
            label="Email"
            type="email"
            name="Email"
            autoComplete="email"
            margin="normal"
            variant="filled"
            fullWidth
          />
          <TextField
            id="filled-company-input"
            onChange={handleChange("company")}
            value={values.company}
            label="Company"
            type="company"
            name="Company"
            autoComplete="company"
            margin="normal"
            variant="filled"
            fullWidth
          />
          <TextField
            id="filled-subject-input"
            onChange={handleChange("subject")}
            value={values.subject}
            label="Subject"
            type="subject"
            name="Subject"
            autoComplete="subject"
            margin="normal"
            variant="filled"
            fullWidth
          />
          <TextField
            id="filled-multiline-flexible"
            label="Message"
            multiline
            rowsMax="8"
            rows="7"
            value={values.message}
            onChange={handleChange("message")}
            margin="normal"
            helperText="Write your message"
            variant="filled"
            type="text"
            name="Message"
            fullWidth
          />
          <ReCAPTCHA
            sitekey="6Ld94swUAAAAAOaMyM7mQhyd8qS7LgZLyVTijhwG"
            onChange={onChange}
          />
          <Button
            onClick={handleForm}
            form="contactForm"
            size="large"
            color="primary"
            disabled={
              formStatus == "sending" || formStatus == "unverified"
                ? true
                : false
            }
          >
            {formStatus == "sending" ? "SENDING" : "SEND"}
          </Button>
        </form>
      </Grid>
      {formStatus === 1 && (
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          open={setFormStatus}
          autoHideDuration={6000}
          onClose={handleClose}
          message={<span>Thank you for contacting us</span>}
          action={[
            <IconButton
              key="close"
              aria-label="close"
              color="inherit"
              onClick={handleClose}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
      )}
    </Grid>
  )
}

export default SubmitForm
